import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import SVG from "../../SVG";
import { Tooltip } from "react-tooltip";
import { toPersianDigits } from "../../../helper/toPersianDigits";

export default function Items({
  svg_name,
  title,
  isActive = false,
  haveNotifications = false,
  notifCount = null,
  href = "",
  showTitle = true,
  tooltipEnabled = true,
  onClick = () => {},
}) {
  const shouldShowTooltip = tooltipEnabled && !showTitle;

  return (
    <Link
      to={href}
      onClick={onClick}
      className={`relative min-w-max min-h-10 p-2 flex items-center gap-5 cursor-pointer hocus:bg-gray-200 dark:hocus:bg-white/5 rounded-lg outline-none ${
        isActive && "!bg-neutral-700 drop-shadow-md"
      }`}
      data-tooltip-id={shouldShowTooltip ? title : undefined}
      data-tooltip-content={shouldShowTooltip ? title : undefined}
    >
      {typeof document !== "undefined" && shouldShowTooltip &&
        createPortal(
          <Tooltip
            id={title}
            place="left"
            positionStrategy="fixed"
            style={{ zIndex: 9999 }}
            className="!py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-cyan-600 !rounded-lg"
          />,
          document.body,
        )}
      <SVG
        name={svg_name}
        active={isActive}
        classname={`w-5 
          ${isActive ? "stroke-white" : "stroke-zi-blue-dark dark:stroke-white"} 
          `}
      />
      {showTitle && (
        <p
          className={`text-xs font-light ${
            isActive
              ? "text-white drop-shadow-md"
              : "text-zi-text-light dark:text-zi-text-dark"
          }`}
        >
          {title}
        </p>
      )}
      {haveNotifications && !showTitle && (
        <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-amber-500" />
      )}
      {haveNotifications && showTitle && (
        <div
          className={`absolute flex justify-end items-center gap-1 left-1 top-1/2 -translate-y-1/2 rounded-full ${isActive ? "bg-zi-bg1-light" : "bg-zi-blue-light"} dark:bg-zi-buttonbg-primary py-1 px-2 text-[10px] font-thin ${isActive ? "text-zi-text-light" : "text-zi-text-dark"} dark:text-zi-text-dark`}
        >
          <span>{toPersianDigits(notifCount || 0)}</span>
          <span>مورد جدید</span>
        </div>
      )}
    </Link>
  );
}
